if (!customElements.get('greeting-card-message')) {
  customElements.define(
    'greeting-card-message',
    class GreetingCardMessage extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) this.initialize();
        });
      }

      initialize() {
        if (this.abortController && !this.abortController.signal.aborted) return;

        this.productInfo = this.closest('product-info');
        this.textarea = this.querySelector('[data-greeting-card-message-input]');
        this.counter = this.querySelector('[data-greeting-card-message-count]');
        this.productFormId = this.dataset.productFormId;

        if (!this.productInfo || !this.textarea || !this.productFormId) return;

        this.abortController = new AbortController();
        this.unsubscribeCallbacks = [];

        this.textarea.addEventListener('input', () => this.updateCounter(), {
          signal: this.abortController.signal,
        });

        this.productInfo.addEventListener('change', (event) => this.handleOptionChange(event), {
          signal: this.abortController.signal,
        });

        this.productInfo.addEventListener('submit', (event) => this.validateMessage(event), {
          capture: true,
          signal: this.abortController.signal,
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribeCallbacks.push(
            subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, () => this.sync()),
            subscribe(PUB_SUB_EVENTS.variantChange, () => this.sync())
          );
        }

        this.updateCounter();
        this.sync();
      }

      disconnectedCallback() {
        window.clearTimeout(this.syncTimeout);
        this.abortController?.abort();
        this.unsubscribeCallbacks?.forEach((unsubscribe) => unsubscribe());
        this.unsubscribeCallbacks = [];
      }

      handleOptionChange(event) {
        if (!event.target.closest('variant-selects, variant-radios')) return;

        window.clearTimeout(this.syncTimeout);
        this.syncTimeout = window.setTimeout(() => this.sync(), 0);
      }

      getSelectedOptionValues() {
        const variantPicker = this.productInfo?.querySelector('variant-selects, variant-radios') || document.querySelector('variant-selects, variant-radios');
        if (!variantPicker) return [];

        return Array.from(variantPicker.querySelectorAll('input:checked, select, option:checked')).map((input) =>
          String(input.value || input.textContent || '').trim().toLocaleLowerCase()
        );
      }

      sync() {
        if (!this.isConnected) return;

        const isPrintedMessage = this.getSelectedOptionValues().some((value) => value.includes('printed'));

        this.hidden = !isPrintedMessage;
        this.textarea.disabled = !isPrintedMessage;
        this.textarea.required = isPrintedMessage;

        if (isPrintedMessage) {
          this.textarea.name = 'properties[Message]';
          this.textarea.setAttribute('form', this.productFormId);
        } else {
          this.textarea.setCustomValidity('');
          this.textarea.removeAttribute('name');
          this.textarea.removeAttribute('form');
        }
      }

      updateCounter() {
        this.textarea.setCustomValidity('');
        if (this.counter) this.counter.textContent = `${this.textarea.value.length}/500`;
      }

      validateMessage(event) {
        if (event.target.id !== this.productFormId || this.hidden || this.textarea.value.trim() !== '') return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.textarea.setCustomValidity('Please enter the message to be printed inside the card.');
        this.textarea.reportValidity();
        this.textarea.focus();
      }
    }
  );
}
